import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  return {
    title: get(data, 'mgv2Title', null),
    models: data.mgv2Series.map(item => {
      var hrefArr = get(item, 'link', null).split('/range/');
      var href = `/range/${hrefArr[1].split('?')[0]}`;
      var model = get(item, 'acf_series.seriesSpecsRep[0].seriesSpecRepFeaturedModel[0].acf_floor_plan', null);
      var img = get(model, 'modelExternalImagesRep[0].modelExternalImagesRepImage', null);
      var subTitle = get(item, 'acf_series.seriesRange[0].title', null);
      if (subTitle && subTitle.endsWith('s')) {
        subTitle = subTitle.slice(0, -1);
      }
      var totalSleeps = parseInt(get(model,'modelSleepAdditionalStandard',0)) + parseInt(get(model,'modelSleepAdultStandard',0)) + parseInt(get(model,'modelSleepChildrenStandard',0));
      if (isNaN(totalSleeps)) {
        totalSleeps = 0;
      }
      var sleepingMax = parseInt(get(item, 'acf_series.sleepingMax', 0));
      if (isNaN(sleepingMax)) {
        sleepingMax = 0;
      }
      var sleeps = Math.max(totalSleeps, sleepingMax);
      sleeps = sleeps > 0 ? sleeps : '';
      return {
        id: get(item, 'id', null),
        title: get(item, 'title', null).replace(subTitle, '').replace('Jayco', '').trim(),
        subTitle,
        href,
        sleeps,
        compareValues: {
          rangeId: get(item, 'acf_series.seriesRange[0].id', null),
          seriesId: get(item, 'id', null),
          spec: get(item, 'acf_series.seriesSpecsRep[0].seriesSpecRepTitle', null),
          model: get(model, 'modelLayoutId', null)
        },
        image: img ? refactorRespImg(img, [{
          size: 'default',
          key: 'image_size_300x200',
        },{
          size: 'md',
          key: 'image_size_400x264',
        }]): null
      }
    })
  }
}
